import { FC } from "react";
import Modal from "..";
import ContactUsForm from "@/components/contact-support";
import { Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

type ContactSupportModal = StandardModalProps;

const ContactSupportModal: FC<ContactSupportModal> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} maxWidth="sm" hideClose>
      <Box px={2}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <ContactUsForm onClose={onClose} />
      </Box>
    </Modal>
  );
};

export default ContactSupportModal;
